var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkiableTerrain(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#skiable-terrain_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.982 26.002l-3.414-3.414a2.587 2.587 0 00-.67-2.5L31.911 13.1l-.203-.203a5.157 5.157 0 00-3.336-1.505l-7.057-7.057 1.301-1.302-1.83-1.83-1.302 1.301L16.98 0l-1.83 1.83 2.504 2.505-1.442 1.442 1.83 1.83 1.442-1.442 5.932 5.932a5.187 5.187 0 00-1.03.8l-3.284 3.284a7.007 7.007 0 000 9.909l2.658 2.657c.58.581.58 1.523 0 2.104l-4.443 4.443L6.228 22.205l-1.83 1.83 17.44 17.441A8.56 8.56 0 0027.931 44a8.56 8.56 0 006.093-2.524l-1.83-1.83a5.99 5.99 0 01-4.263 1.765 5.99 5.99 0 01-4.263-1.765l-.69-.69 6.614-6.615a3.594 3.594 0 000-5.083L27 24.665l4.577-4.577 3.66 3.661c.678.678 1.638.9 2.501.67l3.414 3.414 1.831-1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.645 9.897a4.53 4.53 0 10-9.061 0 4.53 4.53 0 009.061 0zM8.253 8.674l1.83-1.83 5.707 5.707-1.83 1.83-5.707-5.707zM1.017 8.556l1.83-1.83 6.471 6.471-1.83 1.83-6.471-6.47z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "skiable-terrain_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiableTerrain);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "459cd5f0ed43ff290ca21ce807363d2c.svg";
export { MemoForwardRef as ReactComponent };